
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import NeuriteGrid from '../../components/neurite_grid';

//material ui:
import { withStyles } from '@material-ui/core/styles';

//actions:
import { navigate, openDialog, hideDialog } from '../../actions';
import { getUsuarios } from '../../actions/perfiles_usuario_actions';
import { getUsuariosKD } from '../../actions/perfiles_usuario_actions';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
        margin: theme.spacing(1)
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        dispay: 'block'
    },
    bottomBtn: {
        position: 'absolute',
        right: '0',
        bottom: '0',
        margin: theme.spacing(1)
    },
    button: {
        margin: theme.spacing(1)
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresPerfilesUsuario extends Component {

    constructor(props) {
        super(props);

        this.state = {
            usuarios: []
        }
    }

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        if ( this.props.kd)
            this.props.getUsuariosKD(this.props.kd.centro_id);
        else
            this.props.getUsuarios();

    };

    // componentDidUpdate = (prevProps, prevState) =>{

    // }

    editUsuario = (usuario) => {
        this.props.navigate("edit_usuario/" + usuario.id);
    }

    newUsuario = () => {
        this.props.navigate("edit_usuario/" + -1);
    }

    render() {

        const { classes } = this.props;

        let columnsUser = [
            { key: 'codigoUsuario', name: 'Códigoo de usuario', editable: false, dragable: false, width: 150, },
            { key: 'nombre', name: 'Nombre', editable: false, dragable: false, width: 200, },
            { key: 'centro', name: 'Centro', editable: false, dragable: false, width: 150, },
            { key: 'activo', name: 'Activo', type: 'bool', editable: false, dragable: false, width: 52, },
        ];
        if ( this.props.kd )  columnsUser.splice(2,1);

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />

                    <NeuriteGrid
                        id="m_a_p_u"
                        columns={columnsUser}
                        rows={this.props.usuarios}
                        buttonEdit={true}
                        buttonDelete={false}
                        buttonNew={true}
                        onEditClick={this.editUsuario}
                        onNewRowClick={this.newUsuario}
                        //onDeleteClick={this.deleteZona}
                        height={400}
                        enableFilter={true}

                    />
            </div>
        );

    };

};

MaeAuxiliaresPerfilesUsuario.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    //centroId: PropTypes.number.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    //getZonasCentro: PropTypes.func.isRequired,
    //modifyZonaCentro: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        usuarios: state.perfilesUsuario.usuarios,
        kd: state.userProfile.kd,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getUsuarios,
        getUsuariosKD,
        openDialog,
        hideDialog,
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresPerfilesUsuario));